<template>
    <header class="flex items-center gap-4 px-4 h-14 border-b border-default bg-default">
        <RouterLink :to="{ name: 'todos' }" class="font-semibold text-highlighted">
            {{ $t('todo.todos') }}
        </RouterLink>

        <nav class="flex items-center gap-1 ml-4">
            <UButton
                :to="{ name: 'todos' }"
                :label="$t('todo.todos')"
                icon="i-lucide-list-checks"
                color="neutral"
                variant="ghost"
            />
            <UButton
                :to="{ name: 'settings' }"
                :label="$t('general.settings')"
                icon="i-lucide-settings"
                color="neutral"
                variant="ghost"
            />
        </nav>

        <div class="flex items-center gap-2 ml-auto">
            <UTooltip :text="colorModeLabel">
                <UButton
                    :icon="colorModeIcon"
                    color="neutral"
                    variant="ghost"
                    :aria-label="colorModeLabel"
                    @click="cycleColorMode"
                />
            </UTooltip>

            <span v-if="appStore.userData" class="text-sm text-muted hidden lg:inline">
                {{ appStore.userData.name }}
            </span>

            <UButton
                :label="$t('general.logout')"
                icon="i-lucide-log-out"
                color="neutral"
                variant="subtle"
                @click="logout"
            />
        </div>
    </header>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRouter } from 'vue-router'

    import { useAppStore } from '@/stores/app'

    const { t }    = useI18n()
    const router   = useRouter()
    const appStore = useAppStore()

    const modes = ['auto', 'light', 'dark'] as const

    const colorModeIcon = computed(() => {
        if (appStore.colorMode === 'light') return 'i-lucide-sun'
        if (appStore.colorMode === 'dark')  return 'i-lucide-moon'

        return 'i-lucide-monitor'
    })

    const colorModeLabel = computed(() => `${t('general.theme')}: ${t(`theme.${appStore.colorMode}`)}`)

    const cycleColorMode = () => {
        const next = (modes.indexOf(appStore.colorMode as typeof modes[number]) + 1) % modes.length
        appStore.colorMode = modes[next]
    }

    const logout = async () => {
        appStore.setLogout()
        await router.push({ name: 'login' })
    }
</script>
